// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gKrn","field":"styles_field__33fbw","fieldCol":"styles_fieldCol__kMqeT","diffCol":"styles_diffCol__2JFEI","diff":"styles_diff__1gIqg"};